export default __webpack_public_path__ + "static/media/ic-delete.047c55b0.svg";